// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../../shared/Ui.re.mjs";
import * as HomeAtoms from "../../atoms/home/HomeAtoms.re.mjs";
import * as HomeContent from "./HomeContent.re.mjs";
import * as Core from "@linaria/core";
import * as HomeMolecules from "../../molecules/home/HomeMolecules.re.mjs";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

let spans = [
  "md:col-span-7",
  "md:col-span-5",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4"
];

function spanFor(index) {
  return spans[Primitive_int.mod_(index, spans.length)];
}

function MadeInUSASection(props) {
  let pieces = props.pieces;
  return JsxRuntime.jsx("section", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(HomeAtoms.Eyebrow.make, {
                  children: t`Made in USA · By American Artists`,
                  className: Core.cx("mb-6")
                }),
                JsxRuntime.jsx(HomeAtoms.SerifHeading.make, {
                  children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      t`Painted in America,`,
                      JsxRuntime.jsx("br", {}),
                      JsxRuntime.jsx("span", {
                        children: t`by hand.`,
                        className: Core.cx("italic text-gray-700")
                      })
                    ]
                  }),
                  className: Core.cx("text-4xl md:text-5xl lg:text-6xl")
                })
              ],
              className: Core.cx("md:col-span-8")
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("p", {
                children: t`Instapainting is the only art platform with artists around the world-including American artists-ready to take your order. Here are some recent pieces made in America.`,
                className: Core.cx("text-gray-600 font-light leading-relaxed")
              }),
              className: Core.cx("md:col-span-4")
            })
          ],
          className: Core.cx("grid grid-cols-1 md:grid-cols-12 gap-y-8 md:gap-x-16 mb-16 md:mb-20 items-end")
        }),
        pieces.length === 0 ? JsxRuntime.jsx("p", {
            children: t`Recent pieces made in America will appear here soon.`,
            className: Core.cx("text-sm text-gray-500 font-light italic")
          }) : JsxRuntime.jsx("div", {
            children: pieces.map((piece, idx) => JsxRuntime.jsxs("figure", {
              children: [
                JsxRuntime.jsx("a", {
                  children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Ui.DImg.make, {
                      src: piece.src,
                      alt: piece.alt,
                      className: Core.cx("w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]"),
                      imgixParams: HomeMolecules.portraitParams(),
                      sizes: "(min-width: 768px) 50vw, 100vw",
                      width: 800,
                      height: 1000
                    }),
                    className: Core.cx("relative overflow-hidden bg-gray-100 aspect-[4/5]")
                  }),
                  className: Core.cx("block"),
                  href: piece.link
                }),
                JsxRuntime.jsxs("figcaption", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: HomeAtoms.pad(idx + 1 | 0),
                      className: Core.cx("text-[10px] tracking-widest text-gray-400 font-light tabular-nums")
                    }),
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                          children: piece.title,
                          className: Core.cx("font-serif font-light italic text-base text-gray-900 leading-snug")
                        }),
                        JsxRuntime.jsx("p", {
                          children: piece.subtitle,
                          className: Core.cx("mt-1 text-xs tracking-wide text-gray-500 font-light")
                        })
                      ],
                      className: Core.cx("flex-1")
                    })
                  ],
                  className: Core.cx("mt-4 flex items-baseline gap-4")
                })
              ],
              className: Core.cx("group", spanFor(idx))
            }, piece.id)),
            className: Core.cx("grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8")
          }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: t`American artists working in studios from coast to coast.`,
              className: Core.cx("text-sm md:text-base text-gray-600 font-light italic")
            }),
            JsxRuntime.jsx(HomeAtoms.ArrowLink.make, {
              href: HomeContent.madeInAmericaLink,
              label: t`Browse Made in America`
            })
          ],
          className: Core.cx("mt-16 md:mt-20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-gray-200 pt-8")
        })
      ],
      className: Core.cx("max-w-6xl mx-auto")
    }),
    className: Core.cx("w-full bg-[#faf9f6] px-6 md:px-12 py-24 md:py-32")
  });
}

let make = MadeInUSASection;

export {
  spans,
  spanFor,
  make,
}
/*  Not a pure module */
